/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetEntityTracking = require('../services/GetEntityTracking');

var DepKeyThirdPartyVendorDashboardView = require('../views/DepKeyThirdPartyVendorDashboardView');

module.exports = function(entityId, entityTrackingId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetEntityIdentifiers(entityId), GetEntityTracking(entityTrackingId))
    .done(function(entityIdentifiers, entityTracking) {
      NavUtils.navigate('#dep/entity/' + entityId + '/key-third-party-vendor/' + entityTrackingId + '/dashboard');
      Scaffold.content.show(
        new DepKeyThirdPartyVendorDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({
            entityId: entityId,
            entityTrackingId: entityTrackingId,
            entityName: entityIdentifiers.entityName,
            entityTypeId: entityIdentifiers.entityTypeId,
            entityCategoryId: entityIdentifiers.categoryId,
            entityTracking: entityTracking
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
